import React from 'react'
import Layout from '../components/Layout'
import CallBackBanner from '../components/CallBackBanner'
import GeneralHeader from '../components/Header/GeneralHeader'
import WhatIsResearch from '../components/WhatIsResearch/WhatIsResearch'
import CareersGrid from '../components/CareersGrid/CareersGrid'

const breadcrumbData = [
  {
    title: 'Home',
    url: '/',
  },
  {
    title: 'Careers',
    url: '/careers',
  },
]

const Careers = () => {
  return (
    <Layout activeLink="/careers" title="R&D Careers" description="R&D Careers">
      <GeneralHeader breadcrumbData={breadcrumbData} heading="Careers" />
      <WhatIsResearch
        tag="WORKING WITH US"
        heading="At RDA we make everyday interesting"
        body={[
          'The breadth and diversity of our client base ensures there is always a tremendous variety in the briefs we receive. But at the same time, your career at RDA will give you an expert understanding of how Research & Development works. In fact, a day’s work can seldom be more fulfilling than when you are helping to deliver the funds that keep the UK at the forefront of global industry.',
          'Here at RDA you’ll be contributing to the development of the imaginers, the innovators and the iterators who are the beating heart of Great Britain’s sustainable future.Here are some of the positions currently available at RDA:',
        ]}
        maxwidth="893px"
      />
      <CareersGrid
        data={[
          {
            position: 'Accountant',
            required:
              'We are seeking a detail-oriented part-qualified Accountant who will play a vital part in maintaining the financial health of our company by ensuring the accuracy and integrity of our financial records.',
            url: '/accountant.pdf',
            details:
              'Whilst industry knowledge of Tax would be beneficial, this is not essential to succeed in the role.  With our support, you will be able to apply your skills, expertise and desire for knowledge to become a specialist in this field',
          },
          {
            position: 'Client Manager',
            required:
              'The purpose of the Client Manager role is to develop an understanding of R&D Tax Credits Legislation in order to effectively manage and develop client relationships across a portfolio of sectors.',
            url: '/client_manager_new.pdf',
            details:
              'This is a critical role to ensure we maintain our high service levels and effectively manage and develop client relationships across a portfolio of sectors as part of the Research and Development Expenditure Credit (RDEC) R&D tax credit scheme.'
            },
          {
            position: 'Senior Report Writer',
            required:
              'We have an exciting opportunity for a highly self-motivated and enthusiastic candidate to join our Report Writing Team, as we continue to accelerate our considerable growth.',

            url: '/Report_Writer.pdf',
            details:
              'The Senior Report Writer will provide comprehensive and professionally written content, presenting detailed technical and specialist information in a form that can be easily interpreted by a wider, nontechnical audience.',
          },
          {
            position: 'R&D Finance & Tax Consultant',
            required:
              'We are seeking an R&D Finance & Tax Consultant to our growing team. You will work as part of RDA’s Delivery Team, supporting client management and report writing by providing robust financial analysis, compliant cost allocation, and clear tax schedules that underpin high-quality claims.',
            url: '/rd_finance_and_tax_consultant.pdf',
            details:
              'As an R&D Finance & Tax Consultant, you will take the lead on the finance and tax aspects of R&D claims, ensuring submissions are accurate, compliant, and maximised under HMRC rules.',
          },
        ]}
      />

      <CallBackBanner />
    </Layout>
  )
}

export default Careers
